import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from 'axios';
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import { observable, makeObservable } from "mobx";
import { IoIosArrowRoundBack } from "react-icons/io";
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import config from "../config";
import ThreeDotsLoading from "../Components/ThreeDotsLoading";
import { observer, inject } from "mobx-react";
@inject("store")
@observer
class Login extends Component {
  @observable email = "";
  @observable password = "";
  @observable fname = "";
  @observable lname = "";
  @observable errorMessage = "";
  @observable successMessage = ""

  constructor() {
    super();
    this.state = {
      passwordVisibility: false,
      passwordtype: "password",
      loading: false,
    };
    makeObservable(this);
  }

  onChange = (val) => {
    this.currentPromptOption = val;

    console.log(this.currentPromptOption);
  };

  onVisibilityChange = () => {
    this.setState((prevState) => ({
      passwordVisibility: !prevState.passwordVisibility,
    }));
  };

  onChangeAny = (val, attr) => {
    this[attr] = val;
    this.errorMessage = "";
  };

  onLogin = async (e) => {
    try {
      e.preventDefault();
       this.setState(() => ({
        loading: true,
      }));
      let data = await this.props.store.api
        .post("/auth/signin", {
          email: this.email,
          password: this.password,
        })
        .then(({ data }) => data);
      this.props.store.loginWithDataTokenAndProfile(data);
    } catch (err) {
      console.log(err);
      console.log(err?.response?.data?.message);
      this.setState(() => ({
        loading: false,
      }));
      if (err?.response?.data?.message) {
        this.errorMessage = err?.response?.data?.message;
      }
    }
  };

  onSignup = async (e) => {
    try {
      e.preventDefault();
      this.setState(() => ({
        loading: true,
      }));
      this.errorMessage = "";
      console.log("signup");
      let data = await this.props.store.api
        .post("/auth/signup", {
          email: this.email,
          password: this.password,
          fname: this.fname,
          lname: this.lname,
          referral: this.props.store.referral,
        })
        .then(({ data }) => data);
      console.log(`onSignup`, data);
      if (data.token && data.profile) {
        this.props.store.loginWithDataTokenAndProfile(data);
  
        // Call submitSubscription function after successful signup
        await this.submitSubscription(config.stripe.free);
      }
    } catch (err) {
      console.log(err);
      console.log(err?.response?.data?.message);
      this.setState(() => ({
        loading: false,
      }));
      if (err?.response?.data?.message) {
        this.errorMessage = err?.response?.data?.message;
      }
    }
  };
  

// API Call directly to Stripe Checkout
submitSubscription = async (priceId) => {
  try {
    const response = await axios.post(
      this.props.store.baseURL + "user/stripe/subscribe",
      {
        token:
          this.props.store.api.defaults.headers.common["x-access-token"],
        priceId: config.stripe.free,
      }
    );

    if (response.data && response.data.url) {
      window.location.href = response.data.url;
    } else {
      // Handle the case where the response doesn't have the expected format
    }
  } catch (error) {
    console.error(error);
  }
};

  onForgotPassword = async (e) => {
    try {
      e.preventDefault();
      this.errorMessage = "";
      await this.props.store.api.post("/forgot-password", {
        email: this.email
      })
      this.successMessage = "Check your email for a link to reset your password"
    } catch (err) {
      console.log(err.response.data);
      if (err.response.data) {
        this.errorMessage = err.response.data;
      }
    }
  };

  onResetPassword = async (e) => {
    try {
      e.preventDefault();
      this.errorMessage = "";
      await this.props.store.api.post("/reset-password", {
        email: this.props.store.profile.email,
        id: this.props.store.profile._id,
        password: this.password,
        resetToken: this.props.store.profile.reset_token,
      }).then(() => this.props.history.push(`/login`))
    } catch (err) {
      console.log(err);
      console.log(err?.response?.data?.message);
      if (err?.response?.data?.message) {
        this.errorMessage = err?.response?.data?.message;
      }
    }
  }

  // Currently Selected Input Option

  render() {
    return (
      <>
        <Helmet>
          <title>{`Login - MealPalAI`}</title>
        </Helmet>
        <div className="container mx-auto lg:px-4 py-4 min-h-screen flex flex-col items-center justify-center">
          <div className={` md:min-w-0 bg-dark-4 rounded-xl w-4/5 lg:w-1/3`}>
            <div className="text-center mb-0 mt-6 md:mt-20">
              <div className="mx-auto  text-center">
                <img
                  src="/ailogo.svg"
                  className="logo-app h-20 mx-auto"
                  alt="Agent AI"
                />
              </div>
            </div>
            <div className="px-4 py-4 md:px-12 md:py-12 same_width_n">
              <Switch>
                <Route path="/login">
                  <Logon
                    passwordtype={this.passwordtype}
                    onVisibilityChange={this.onVisibilityChange}
                    passwordVisibility={this.state.passwordVisibility}
                    landingPageUrl={this.props.store.landingPageUrl}
                    email={this.email}
                    password={this.password}
                    signUp={this.signUpWithGoogle}
                    onChange={this.onChangeAny}
                    onLogin={this.onLogin}
                    errorMessage={this.errorMessage}
                     loading={this.state.loading}
                  />
                </Route>
                <Route path="/signup">
                  <Signup
                    passwordtype={this.passwordtype}
                    onVisibilityChange={this.onVisibilityChange}
                    passwordVisibility={this.state.passwordVisibility}
                    email={this.email}
                    password={this.password}
                    fname={this.fname}
                    lname={this.lname}
                    onChange={this.onChangeAny}
                    onSignup={this.onSignup}
                    errorMessage={this.errorMessage}
                     loading={this.state.loading}
                  />
                </Route>
                <Route path="/forgotPassword">
                  <ForgotPassword
                    email={this.email}
                    onChange={this.onChangeAny}
                    onForgotPassword={this.onForgotPassword}
                    errorMessage={this.errorMessage}

                  />
                </Route>
                <Route path="/resetPassword">
                  <ResetPassword
                    onVisibilityChange={this.onVisibilityChange}
                    passwordVisibility={this.state.passwordVisibility}
                    password={this.password}
                    onChange={this.onChangeAny}
                    onReset={this.onResetPassword}
                  />
                </Route>
                <Route>
                  <Redirect to="/login" />
                </Route>
              </Switch>

              {this.successMessage ? (
                <div className="text-c-yellow text-bold bg-dark-primary border-radius-12  py-2 text-center mt-4 mb-4">
                  Check your email for a link to reset your password
                </div>
              ) : null}
            </div>
            <hr></hr>
            <a
              href="/"
              className="flex justify-center align-center block text-center bg-dark-5 text-white text-sm p-3 rounded-b-lg  cursor-pointer text-lg line-height-2"
            >
              <IoIosArrowRoundBack size="2em" /> Back
            </a>
          </div>
        </div>
      </>
    );
  }
}

const Logon = observer(
  ({
    active,
    email,
    password,
    onChange,
    onLogin,
    landingPageUrl,
    signUp,
    passwordVisibility,
    onVisibilityChange,
    passwordtype,
    errorMessage,loading
  }) => {
    return (
      <>
        <form onSubmit={onLogin}>
          <div className="mt-3 text-center ">
            <p className="text-white text-center mb-4">
              Don't have an account ?{" "}
              <NavLink to="/signup" className="text-c-yellow">
                Sign Up
              </NavLink>
            </p>
            <div className="flex flex-col flex-1">
              {/* <label className="text-white text-sm block mt-4 inline-block text-left pl-4">Email Address</label> */}
              <input
                value={email}
                onChange={(e) => onChange(e.target.value, "email")}
                focus="true"
                type="email"
                className=" placeholder-white text-white focus:shadow-none focus:outline-none  border-c-gray px-4 py-2 bg-dark-4 inline-block login-input place-holder-text"
                placeholder="Enter your email"
              />
            </div>
            <div className="flex flex-col flex-1 mt-3">
              {/* <label className="text-white text-sm block mt-4 inline-block text-left pl-4">Password</label> */}
              <div className="relative w-full block">
                <input
                  value={password}
                  onChange={(e) => onChange(e.target.value, "password")}
                  type={passwordVisibility ? "text" : "password"}
                  className="placeholder-white w-full relative text-white focus:shadow-none focus:outline-none border-c-gray px-4 py-2 bg-dark-4 block login-input place-holder-text"
                  placeholder="Enter your password"
                />
                {passwordVisibility ? (
                  <FiEyeOff
                    className="absolute right-4 top-3 z-10 text-white cursor-pointer"
                    onClick={onVisibilityChange}
                  />
                ) : (
                  <FiEye
                    className="absolute right-4 top-3 z-10 text-white cursor-pointer"
                    onClick={onVisibilityChange}
                  />
                )}
              </div>
            </div>
            <div className="flex flex-col">
              <button
                type="submit"
                className="font-bold border-c-radius text-lg px-4 py-2 bg-c-yellow text-black mt-4 inline-block login-btn"
              >
                {loading ? <ThreeDotsLoading /> : "Log in"}
              </button>
            </div>
            <div className="mt-2">
              <NavLink
                to="/forgotPassword"
                className="text-c-yellow text-center pt-4"
              >
                Forgot your password?
              </NavLink>
            </div>
            {errorMessage ? (
              <p className="mt-6 text-red-500 text-bold border-radius-12 text-center">
                {errorMessage}
              </p>
            ) : null}
          </div>
        </form>
      </>
    );
  }
);

const Signup = observer(
  ({
    active,
    email,
    password,
    fname,
    lname,
    onChange,
    onSignup,
    passwordVisibility,
    onVisibilityChange,
    passwordtype,
    errorMessage,loading
  }) => {
    return (
      <>
        <form onSubmit={onSignup}>
          <div className="mt-3 text-center ">
            <p className="text-white text-center mb-4">
              Already have an account?{" "}
              <NavLink to="/login" className="text-c-yellow">
                Log in
              </NavLink>
            </p>

            <div className="md:flex">
              <div className="flex flex-col min-w-0 md:pr-2 flex-1">
                {/* <label className="text-white text-sm block mt-4 inline-block text-left pl-4">First Name</label> */}
                <input
                  value={fname}
                  onChange={(e) => onChange(e.target.value, "fname")}
                  type="text"
                  className="placeholder-white text-white focus:shadow-none focus:outline-none  border-c-gray px-4 py-2 bg-dark-4 inline-block login-input place-holder-text"
                  placeholder="First Name"
                />
              </div>
              <div className="mt-3 sm:mt-0 flex flex-col min-w-0 md:pl-2 flex-1">
                {/* <label className="text-white text-sm block mt-4 inline-block text-left pl-4">Last Name</label> */}
                <input
                  value={lname}
                  onChange={(e) => onChange(e.target.value, "lname")}
                  type="text"
                  className="placeholder-white text-white focus:shadow-none focus:outline-none  border-c-gray px-4 py-2 bg-dark-4 inline-block login-input place-holder-text"
                  placeholder="Last Name"
                />
              </div>
            </div>
            <div className="flex flex-col mt-3">
              {/* <label className="text-white text-sm block mt-4 inline-block text-left pl-4">Email Address</label> */}
              <input
                value={email}
                onChange={(e) => onChange(e.target.value, "email")}
                focus="true"
                type="email"
                className="placeholder-white text-white focus:shadow-none focus:outline-none  border-c-gray px-4 py-2 bg-dark-4 inline-block login-input place-holder-text"
                placeholder="Email Address"
              />
            </div>
            {/* <div className="flex flex-col mt-3"> */}
            {/* <label className="text-white text-sm block mt-4 inline-block text-left pl-4">Password</label> */}
            {/* <input value={password} onChange={e => onChange(e.target.value, 'password')} type="password" className="placeholder-white text-white focus:shadow-none focus:outline-none  border-c-gray px-4 py-2 bg-dark-4 inline-block login-input place-holder-text" placeholder="Create password" />
                    </div> */}
            <div className="relative w-full block mt-3">
              <input
                value={password}
                onChange={(e) => onChange(e.target.value, "password")}
                type={passwordVisibility ? "text" : "password"}
                className="placeholder-white w-full relative text-white focus:shadow-none focus:outline-none border-c-gray px-4 py-2 bg-dark-4 block login-input place-holder-text"
                placeholder="Create Password"
              />
              {passwordVisibility ? (
                <FiEyeOff
                  className="absolute right-4 top-3 z-10 text-white cursor-pointer"
                  onClick={onVisibilityChange}
                />
              ) : (
                <FiEye
                  className="absolute right-4 top-3 z-10 text-white cursor-pointer"
                  onClick={onVisibilityChange}
                />
              )}
              <div className="flex flex-col">
                <button
                  type="submit"
                  className="font-bold border-c-radius text-lg px-4 py-2 bg-c-yellow text-black mt-4  inline-block login-btn"
                >
                    {loading ? <ThreeDotsLoading /> : "Sign Up"}
                </button>
                <p className="text-white text-xs text-center mt-2">
  By signing up you agree to our <a href="https://mealpalai.com/terms-of-use" className="text-c-yellow" style={{ textDecoration: "underline" }}>Terms of Use</a>
</p>
                {errorMessage ? (
                  <p className="mt-6 text-red-500 text-bold border-radius-12 text-center">
                    {errorMessage}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }
);

const ForgotPassword = observer(({ onForgotPassword, email, onChange, errorMessage }) => {
  return (
    <>
      <form>
        <div className="mt-3 text-center ">
          <p className="text-white text-center mb-4">Reset your password via email</p>
          <div className="flex flex-col mt-3">
            <input
              value={email}
              onChange={(e) => onChange(e.target.value, "email")}
              focus="true"
              type="email"
              className="placeholder-white text-white focus:shadow-none focus:outline-none  border-c-gray px-4 py-2 bg-dark-4 inline-block login-input place-holder-text"
              placeholder=" joebloggs@gmail.com"
            />
          </div>
          <div className="flex flex-col">
            <button
              type="button"
              onClick={onForgotPassword}
              className="font-bold border-c-radius text-lg px-4 py-2 bg-c-yellow text-black mt-4  inline-block login-btn"
            >
              Submit
            </button>
          </div>
        </div>
        {errorMessage ? (
          <p className="text-white text-bold border-radius-12 mt-7 text-center">
            {errorMessage}
          </p>
        ) : null}
      </form>
    </>
  );
});

const ResetPassword = observer(
  ({ password, onChange, passwordVisibility, onVisibilityChange, onReset }) => {
    return (
      <>
        <form>
          <div className="mt-3 text-center ">
            <p className="text-white text-center mb-4">Choose your new password</p>

            <div className="relative w-full block mt-3">
              <input
                value={password}
                onChange={(e) => onChange(e.target.value, "password")}
                type={passwordVisibility ? "text" : "password"}
                className="placeholder-white w-full relative text-white focus:shadow-none focus:outline-none border-c-gray px-4 py-2 bg-dark-4 block login-input place-holder-text"
                placeholder="Enter your password"
              />
              {passwordVisibility ? (
                <FiEyeOff
                  className="absolute right-4 top-3 z-10 text-white cursor-pointer"
                  onClick={onVisibilityChange}
                />
              ) : (
                <FiEye
                  className="absolute right-4 top-3 z-10 text-white cursor-pointer"
                  onClick={onVisibilityChange}
                />
              )}
            </div>
            <div className="flex flex-col">
              <button
                type="type"
                onClick={onReset}
                className="font-bold border-c-radius text-lg px-4 py-2 bg-c-yellow text-black mt-4  inline-block login-btn"
              >
                Reset Password
              </button>
            </div>
          </div>
        </form>
      </>
    );
  }
);

export default withRouter(Login);